var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "workspaces-list-container" },
    [
      _c(
        "v-card-text",
        { staticClass: "workspace-card" },
        [
          _c("v-text-field", {
            staticStyle: { padding: "0px 10px" },
            attrs: { label: "Search", clearable: "" },
            on: { clear: _vm.clearSearch },
            model: {
              value: _vm.searchText,
              callback: function($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "scrollable-list" },
            [
              !_vm.isLoading
                ? _c(
                    "v-list",
                    { attrs: { "max-height": "600px" } },
                    _vm._l(_vm.filteredBuildings, function(item, index) {
                      return _c(
                        "v-list-item",
                        {
                          key: index,
                          staticClass: "building-list-item",
                          staticStyle: {
                            "border-bottom": "1px rgb(139, 137, 137) solid"
                          }
                        },
                        [
                          _c(
                            "v-list-item-action",
                            { staticClass: "building-list-action" },
                            [
                              _c("v-checkbox", {
                                staticClass: "custom-checkbox",
                                attrs: {
                                  color: "#67a0b4",
                                  "input-value": _vm.isSelected(item.bd_id)
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.toggleBuildingSelection(item)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            { staticClass: "building-list-content" },
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "list-item-title" },
                                [_vm._v(_vm._s(_vm.getBuildingLabel(item)))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _c("v-progress-linear", {
                    attrs: { indeterminate: true, color: "primary" }
                  })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15221a30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15221a30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/components/BuildingsList.vue
// module id = null
// module chunks = 